export const Config = {
	environment: 'development',
	sentry     : {
		dsn        : 'https://1e963edf08a2624c9ec9a03a71bbc51d@trace.windware.net/4',
		sample_rate: 1,
	},
}
